import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/api/authentication/authentication.service';
import { FacadeService } from '../services/facade.service';
@Injectable()
export class AuthGuardService {
	constructor(
		private auth: AuthenticationService,
		private router: Router,
		private facade: FacadeService
	) {}

	canActivate(): boolean {
		const hasLogOut = this.facade.dataStorageService.getJwtToken() === '';
		if (hasLogOut || !this.auth.isAuthenticated()) {
			this.clearStorage();
			this.router.navigate([`/login`], { replaceUrl: true });
			return false;
		}
		return true;
	}

	clearStorage() {
		this.facade.dataStorageService.clearStorage();
		this.facade.dataStorageService.clearSession();
		this.facade.notificationService.ngOnDestroy();
		this.facade.messageService.ngOnDestroy();
	}
}
